import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyB_kqRk4XCFuYAE8fyCe4moHpYiKixqmwk",
  authDomain: "especialista-en-heridas.firebaseapp.com",
  projectId: "especialista-en-heridas",
  storageBucket: "especialista-en-heridas.firebasestorage.app",
  messagingSenderId: "199783381959",
  appId: "1:199783381959:web:d0a2cf931042eafd5f37e2"
};

const app = initializeApp(firebaseConfig);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
